import api from './api'; // Usamos la instancia global

export const getActualSensorsDataByTables = async (tables) => {
  const response = await api.get('/sensors/ultimas-temperaturas', {
    params: { tables },
  });
  return response.data;
};

export const getHistoricalTemperaturesBySensor = async (startDate, endDate) => {
  const response = await api.get('/sensors/historico', {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getTemperaturesPerDayByTable = async (
  prefix,
  startDate,
  endDate
) => {
  const response = await api.get(`/sensors/promedio-dia/equipo/${prefix}`, {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getTemperaturesPerHourByTable = async (
  prefix,
  startDate,
  endDate
) => {
  const response = await api.get(`/sensors/promedio-hora/equipo/${prefix}`, {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getTemperaturesStatisticalByTable = async (
  prefix,
  startDate,
  endDate
) => {
  const response = await api.get(
    `/sensors/temperaturas-estadisticas/equipo/${prefix}`,
    {
      params: { startDate, endDate },
    }
  );
  return response.data;
};

export const getEventsByTable = async (prefix, startDate, endDate) => {
  const response = await api.get(`/sensors/eventos/equipo/${prefix}`, {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getRecordsByTable = async (prefix, startDate, endDate) => {
  const response = await api.get(`/sensors/registros/equipo/${prefix}`, {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getTemperaturesByTable = async (prefix, startDate, endDate) => {
  const response = await api.get(`/sensors/temperaturas/equipo/${prefix}`, {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getTemperaturesByTableAndSensor = async (
  prefix,
  sensorNumber,
  startDate,
  endDate
) => {
  const response = await api.get(
    `/sensors/temperaturas/equipo/${prefix}/sensor/${sensorNumber}`,
    {
      params: { startDate, endDate },
    }
  );
  return response.data;
};

export const getTemperaturesPerDayByTableAndSensor = async (
  prefix,
  sensorNumber,
  startDate,
  endDate
) => {
  const response = await api.get(
    `/sensors/promedio-dia/equipo/${prefix}/sensor/${sensorNumber}`,
    {
      params: { startDate, endDate },
    }
  );
  return response.data;
};

export const getTemperaturesPerHourByTableAndSensor = async (
  prefix,
  sensorNumber,
  startDate,
  endDate
) => {
  const response = await api.get(
    `/sensors/promedio-hora/equipo/${prefix}/sensor/${sensorNumber}`,
    {
      params: { startDate, endDate },
    }
  );
  return response.data;
};

export const getGateStateByTableAndSensor = async (
  prefix,
  sensorNumber,
  startDate,
  endDate
) => {
  const response = await api.get(
    `/sensors/estado-puerta/equipo/${prefix}/sensor/${sensorNumber}`,
    {
      params: { startDate, endDate },
    }
  );
  return response.data;
};

export const getDeviceNamesByTables = async (tables) => {
  const response = await api.get('/sensors/devices', {
    params: { tables },
  });
  return response.data;
};

export const getTemperaturesPerDayByMultipleTables = async (
  tables,
  startDate,
  endDate
) => {
  const response = await api.get('/sensors/temperaturas/promedio-dia', {
    params: { tables, startDate, endDate },
  });
  return response.data;
};

export const getTemperaturesPerHourByMultipleTables = async (
  tables,
  startDate,
  endDate
) => {
  const response = await api.get('/sensors/temperaturas/promedio-hora', {
    params: { tables, startDate, endDate },
  });
  return response.data;
};

export const getEventsByMultipleTables = async (tables, startDate, endDate) => {
  const response = await api.get('/sensors/temperaturas/events', {
    params: { tables, startDate, endDate },
  });
  return response.data;
};

export const getRecordsByMultipleTables = async (
  tables,
  startDate,
  endDate
) => {
  const response = await api.get('/sensors/temperaturas/registros', {
    params: { tables, startDate, endDate },
  });
  return response.data;
};

export const getTemperaturesByMultipleTables = async (
  tables,
  startDate,
  endDate
) => {
  const response = await api.get('/sensors/temperaturas/temperaturas', {
    params: { tables, startDate, endDate },
  });
  return response.data;
};

export const getTemperaturesStatisticalByMultipleTables = async (
  tables,
  startDate,
  endDate
) => {
  const response = await api.get('/sensors/temperaturas-estadisticas', {
    params: { tables, startDate, endDate },
  });
  return response.data;
};
